/* unplugin-vue-components disabled */import { render } from "./files-table.vue?vue&type=template&id=20ba0b8c&scoped=true"
import script from "./files-table.vue?vue&type=script&lang=js"
export * from "./files-table.vue?vue&type=script&lang=js"

import "./files-table.vue?vue&type=style&index=0&id=20ba0b8c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ba0b8c"],['__file',"src/pages/files/files-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20ba0b8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20ba0b8c', __exports__)) {
    api.reload('20ba0b8c', __exports__)
  }
  
  module.hot.accept("./files-table.vue?vue&type=template&id=20ba0b8c&scoped=true", () => {
    api.rerender('20ba0b8c', render)
  })

}


export default __exports__